import isEmpty from 'lodash/isEmpty';

let locales = {};
let current = 'en';

export const init = (value) => (locales = value);

export const setLocale = (locale) => {
    const localeCode = locale.split('-')[0];

    if (!locales[localeCode]) {
        console.warn('There is no "' + localeCode + '" locale');
    } else {
        current = localeCode;
    }
};

export const updateLocaleWith = (value: Partial<Record<string, string>>) =>
    Object.assign(locales[current], value);

/**
 * Usage:
 * localize('greeting_text', {name: 'Ihor', age: 29}, 'ru');
 *
 * @param key string
 * @param replacements object
 * @param localeCode string
 * @returns string
 */
export const localize = (key, replacements = {}, localeCode = '') => {
    if (localeCode === '') {
        localeCode = current;
    }

    if (key === undefined) {
        return '';
    }

    if (!locales[localeCode][key]) {
        console.warn('There is no "' + localeCode + '" localization for "' + key + '"');
        return key;
    }

    if (isEmpty(replacements)) {
        return locales[localeCode][key];
    }

    return locales[localeCode][key].replace(
        new RegExp('%' + Object.keys(replacements).join('%|%') + '%', 'gi'),
        (matched) => replacements[matched.substr(1, matched.length - 2)]
    );
};

export const hasTranslation = (key, localeCode = '') => {
    if (localeCode === '') {
        localeCode = current;
    }

    return !!locales[localeCode]?.[key];
};

export default localize;
